import { render, staticRenderFns } from "./ChecklistTextArea.vue?vue&type=template&id=124e23c4&"
import script from "./ChecklistTextArea.vue?vue&type=script&lang=ts&"
export * from "./ChecklistTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports